const API_URL = process.env.REACT_APP_API_URL;

// Keeps the server's per-field detail on the error, so forms can mark inputs
// rather than showing a bare banner.
const fail = async (res, fallback) => {
  const body = await res.json().catch(() => ({}));
  const err = new Error(body.message || fallback);
  err.fields = body.fields || null;
  err.status = res.status;
  throw err;
};

export const fetchPermissionRegistry = async () => {
  const res = await fetch(`${API_URL}/api/user-management/registry`);
  if (!res.ok) await fail(res, "Failed to load the permission registry");
  return (await res.json()).data;
};

export const fetchUsers = async ({ role = "", search = "", status = "", page = 1, pageSize = 200 } = {}) => {
  const params = new URLSearchParams({ page, pageSize });
  if (role) params.set("role", role);
  if (search.trim()) params.set("search", search.trim());
  if (status) params.set("status", status);
  const res = await fetch(`${API_URL}/api/user-management/users?${params}`);
  if (!res.ok) await fail(res, "Failed to load users");
  return res.json();
};

export const fetchUserPermissions = async (userType, id) => {
  const res = await fetch(`${API_URL}/api/user-management/users/${userType}/${id}`);
  if (!res.ok) await fail(res, "Failed to load this user");
  return (await res.json()).data;
};

export const saveUserPermissions = async (userType, id, permissions) => {
  const res = await fetch(`${API_URL}/api/user-management/users/${userType}/${id}/permissions`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ permissions }),
  });
  if (!res.ok) await fail(res, "Failed to save permissions");
  return (await res.json()).data;
};

export const createStaffUser = async (payload) => {
  const res = await fetch(`${API_URL}/api/user-management/staff`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
  });
  if (!res.ok) await fail(res, "Failed to create staff user");
  return (await res.json()).data;
};

export const updateStaffUser = async (id, payload) => {
  const res = await fetch(`${API_URL}/api/user-management/staff/${id}`, {
    method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
  });
  if (!res.ok) await fail(res, "Failed to update staff user");
  return (await res.json()).data;
};

export const deleteStaffUser = async (id) => {
  const res = await fetch(`${API_URL}/api/user-management/staff/${id}`, { method: "DELETE" });
  if (!res.ok) await fail(res, "Failed to delete staff user");
  return res.json();
};
